import { useIntl } from "react-intl";

import SimpleImageTextSide from "@/patterns/wpl/simple-image-text-side/src";

const Notifications = () => {
    const intl = useIntl();
    const title = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabSection.notifications.title",
        defaultMessage: "Stay up to date with notifications"
    });

    const bodyText = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabSection.notifications.listItem.",
        defaultMessage:
            "Ensure the right people are notified at the right time. New bugs can be routed to the correct team member immediately. Notifications within Jira are not just @mentions, but can also be configured to update someone automatically when a status change occurs. Customize your project, so as things change, Jira Software will keep everyone in sync."
    });
    const imageSrc =
        "https://wac-cdn-2.atlassian.com/dam/jcr:a22173e7-0335-4350-802a-7aca1683e9d2/notifications2x.png?cdnVersion=ece";
    const imageAlt = "notifications";

    return (
        <SimpleImageTextSide
            headerText={title}
            bodyText={bodyText}
            imageLink={imageSrc}
            imageAltText={imageAlt}
            alignItems={"top"}
            rowProps="4-8"
            className="simple-image-text-side-tabs"
        />
    );
};

export default Notifications;
